export default function () {
  const widgetName = 'cardSection';
  const widgetOpts = cardSectionOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (i) {
          $(this).find('.image-container').append('<div class="overlay"></div>')
          $(this).removeAttr('target')
          $(this).find('.moreButton').addClass('button')
          $(this).find('.buyNowButton').addClass('button')
          $(this).find('.image-container').append(`<a class="button overlay-button" href='${slide.items[i].URL}'>Learn More</a>`)
          $(this).find('.buttonwrap').append('<div class="arrow-decoration"></div>')
          $(this).find('.moreButton').remove();
          $(this).find('.buyNowButton').removeAttr('target');

          if (!slide.items[i].URL && !slide.items[i].PurchaseURL) {
            $(this).find('.overlay').remove();
            $(this).find('.overlay-button').remove();
          } if (!slide.items[i].URL) {
            $(this).find('.overlay-button').remove();
          }
        })
      }

      customWidget()

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 9,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    buyNowButton: {
      visible: true,
      text: 'Buy now'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });
}